
import { Component } from "@angular/core";
import { NotificationService } from "../services/notification.service";

@Component({
    selector: "notification-ribbon",
    template: require("./notification.component.html")
})
export class NotificationComponent {
    constructor(private notify: NotificationService) {}
}


/** WEBPACK FOOTER **
 ** ./app/notification/notification.component.ts
 **/